import { css } from 'aphrodite';
import { PlusIcon2 } from '../../../web/components/svgs/icons/PlusIcon';
import { SupportIcon } from '../../../web/components/svgs/icons/SupportIcon';
import { AppDrawerToolbarActionButton } from '../../../web/components-v2/Drawer/AppDrawer';
import type { NewTicketMode } from './NewTicketModal/newTicketDraft';
import { NewTicketMenu } from './NewTicketMenu';
import { supportSharedStyles as ss } from './styles/supportSharedStyles';

export function SupportNewTicketDrawerButton({ onSelect }: { onSelect: (mode: NewTicketMode) => void }) {
	return (
		<NewTicketMenu
			onSelect={onSelect}
			render={
				<AppDrawerToolbarActionButton aria-label='New ticket' tooltip='New ticket'>
					<span className={css(ss.newTicketDrawerIcon)}>
						<SupportIcon stroke='currentColor' />
						<PlusIcon2 className={css(ss.newTicketDrawerPlus)} width={10} height={10} strokeWidth={4} />
					</span>
				</AppDrawerToolbarActionButton>
			}
		/>
	);
}
